import { Injectable } from '@angular/core';

export class EventData {


  constructor(entityName: string, entityId: any) {
    this.entityName = entityName;
    this.entityId = entityId;
  }

  public entityName: string;
  public entityId: any;
}

@Injectable({
  providedIn: 'root'
})
export class SyncService {

  constructor() { }


  public NotifyEntityChanged(name:string, id:any) {
    const data = JSON.stringify(new EventData(name, id));
    console.log("Sending 'EntitieChange' event with data "+data);
    window.dispatchEvent(new CustomEvent("EntitieChange", { detail: data}));
  }
}
